var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "newUserPaid" } }, [
            _vm._v(_vm._s(_vm.$t("productPenetrationRate")))
          ]),
          _c("el-menu-item", { attrs: { index: "levelPaymentAmount" } }, [
            _vm._v(_vm._s(_vm.$t("levelPaymentAmountOverview")))
          ]),
          _c("el-menu-item", { attrs: { index: "levelPaymentFrequency" } }, [
            _vm._v(_vm._s(_vm.$t("paymentFrequencyPenetrationRate")))
          ])
        ],
        1
      ),
      _c("newUserPaid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "newUserPaid",
            expression: "activeIndex == 'newUserPaid'"
          }
        ],
        ref: "newUserPaid"
      }),
      _c("levelPaymentAmount", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "levelPaymentAmount",
            expression: "activeIndex == 'levelPaymentAmount'"
          }
        ],
        ref: "levelPaymentAmount"
      }),
      _c("levelPaymentFrequency", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "levelPaymentFrequency",
            expression: "activeIndex == 'levelPaymentFrequency'"
          }
        ],
        ref: "levelPaymentFrequency"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }